import React, { useState } from "react";
import Input from "sushiweb/InputTypes/Input";

import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isValidated } from "../../utils";
import {
  getMerchantFacadeImageUploadURL,
  saveMerchantFacadeEntry,
} from "../../store/actions/MerchantFacade";
import NoFooterModal from "../Common/NoFooterModal";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../constants/assets/containers";
import { setStatus } from "../../store/actions/User";
import ImageUploader from "../Common/ImageUploader";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";

const mandatoryFields = ["merchant_external_id"];

const MerchantFacadeAddModal = (props) => {
  const [initialState, setInitialState] = useState({
    merchant_external_id: "",
    presigned_url: "",
    callback_key: "",
    file_name: "",
    s3_file_name: "",
    image_tags: [],
  });

  const {
    handleClose,
    saveMerchantFacadeEntry,
    getMerchantFacadeImageUploadURL,
    setStatus,
  } = props;

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    const validatedState = isValidated(initialState, mandatoryFields);
    if (validatedState === "validated") {
      saveMerchantFacadeEntry(
        initialState.merchant_external_id,
        initialState.s3_file_name,
        initialState.image_tags
      ).then((res) => {
        if (res) {
          const values = { ...initialState };
          values["merchant_external_id"] = "";
          values["presigned_url"] = "";
          values["callback_key"] = "";
          values["file_name"] = "";
          values["s3_file_name"] = "";
          values["image_tags"] = [];
          setInitialState(values);
          handleClose();
        }
      });
    } else {
      setStatus({ type: "error", message: validatedState });
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const handleImageChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    getMerchantFacadeImageUploadURL(payload).then((res) => {
      const values = { ...initialState };

      let fileName = res.file_path.split("/").pop();

      values["presigned_url"] = res.file_upload_url;
      values["s3_file_name"] = fileName;
      values["file_name"] = file.name;
      values["callback_key"] = res.callback_key;
      setInitialState(values);
    });
  };

  const handleImageUrlChange = () => {
    const values = { ...initialState };
    values.presigned_url = "";
    values.callback_key = "";
    setInitialState(values);
  };

  return (
    <NoFooterModal
      header={true}
      heading={`Add Merchant Facade Entry`}
      handleClose={handleClose}
      id="AddMerchantFacadeFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {"Submit"}
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.merchant_external_id}
        id="sushi-input"
        onChange={(e) => handleChange("merchant_external_id", e)}
        label="Merchant external Id"
      />

      <>
        <InfiniteScrollDropdown
          id="image_tags_id"
          modalState={initialState.image_tags}
          keyName="image_tags"
          labelKey="image_tags"
          keyTypeToSet="image_tags"
          label="Set Image Tags..."
          handleChange={(key, _, __, val) =>
            handleChange(key, val)
          }
          multiple
          freeSolo
          makeNoInitialCall
          value={initialState.image_tags || []}
        />
      </>

      <FlexContainer justify="flex-start">
        <FlexContainer>
          <ImageUploader
            handleImageChange={handleImageChange}
            id={`imageUpload`}
            state="Add"
            imageKey={"thumbnail"}
            uploadUrl="/merchant_facade/upload/ack"
            callback_key={initialState.callback_key}
            presign_url={initialState.presigned_url}
            keyName="callback_key"
            maxSize={2}
            handleImageUrlChange={handleImageUrlChange}
            noAckCall
          />
          <div className="flex mb-26 ml-26 text-grey pill">
            <ul>
              <li>Maximum Image Size: 2 MB</li>
              <li>Supported types: PNG/JPG/JPEG</li>
            </ul>
          </div>
        </FlexContainer>
      </FlexContainer>
      {initialState.file_name}
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { MerchantFacade } = state;
  return {
    activeFilters: MerchantFacade.activeFilters,
    currentPage: MerchantFacade.currentPage,
    // nextPageState: MerchantFacade.nextPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveMerchantFacadeEntry: bindActionCreators(
      saveMerchantFacadeEntry,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
    getMerchantFacadeImageUploadURL: bindActionCreators(
      getMerchantFacadeImageUploadURL,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchantFacadeAddModal);
